// A failed naja request only fires `error` and leaves the DOM untouched, which reads as
// "nothing happened" and gets the mail sent twice. submitter comes from form-submit-guard.js.

import naja from 'naja';

const NOTICE_CLASS = 'request-error';

function removeNotice(form) {
  const notice = form.querySelector(`.${NOTICE_CLASS}`);

  if (notice) {
    notice.remove();
  }
}

function showNotice(submitter, message) {
  removeNotice(submitter.form);

  const notice = document.createElement('div');
  notice.className = `row ${NOTICE_CLASS}`;
  notice.setAttribute('role', 'alert');

  const text = document.createElement('div');
  text.className = 'invalid-feedback';
  text.textContent = message;
  notice.append(text);

  const anchor = submitter.closest('.row') ?? submitter;

  anchor.before(notice);
}

naja.addEventListener('start', (event) => {
  const { submitter } = event.detail.options;

  if (submitter?.form) {
    removeNotice(submitter.form);
  }
});

naja.addEventListener('error', (event) => {
  const { submitter } = event.detail.options;
  const message = document.body.dataset.requestError;

  if (!submitter?.form || !message) {
    return;
  }

  showNotice(submitter, message);
});
